module.exports = __webpack_public_path__ + "static/img/Aaclogomax3.2b4e188.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aaclogomax3.png
// module id = JFub
// module chunks = 1